// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"widget-container_wrapper__2BW7w","limitWidth":"widget-container_limitWidth__2ky14"};